import { localize } from 'monaco-editor/esm/vs/nls.js';
const workbenchConfigurationNodeBase = ( Object.freeze({
    'id': 'workbench',
    'order': 7,
    'title': ( localize('workbenchConfigurationTitle', "Workbench")),
    'type': 'object',
}));
export { workbenchConfigurationNodeBase };
